import { observer } from "mobx-react";
import { portalStore } from "../../Stores/portal";
import ControllersSub from "../Portal/Sub/controllers";
import PlayersSub from "../Portal/Sub/players";
import { Dashboard } from "../Portal/Sub/dashboard";
import { TournamentFocus, Tournaments } from "../Portal/Sub/tournaments";
import {
  BrowserRouter,
  createBrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import { Accounting } from "../Portal/Sub/accounting";
import { StoresDashboard } from "../Portal/Sub/Store/storesDashbaord";
import EventsSub from "../Portal/Sub/events";
import { NewStore } from "../Portal/Sub/Store/newStore";
import { EmployeeGrid } from "../Portal/Sub/Employees/employeeGrid";

const _SmartScreen: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/tournaments" element={<Tournaments />}>
        <Route index path=":id" element={<TournamentFocus />} />
      </Route>
      <Route path="/controllers" element={<ControllersSub />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/players" element={<PlayersSub />} />
      <Route path="/accounting/:section?" element={<Accounting />} />
      <Route path="/events" element={<EventsSub />} />

      <Route path="/store" element={<StoresDashboard />} />
      <Route path="/store/create" element={<NewStore />} />
      <Route path="/employees" element={<EmployeeGrid />} />
    </Routes>
  );
};

const SmartScreen = observer(_SmartScreen);

export { SmartScreen };
